import { Component, computed, Input, OnInit, signal } from '@angular/core';
import { CommonModule, NgIf, NgOptimizedImage } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { RoutingService } from 'src/app/services/routing.service';


@Component({
  selector: 'product-related-card',
  standalone: true,
  imports: [ CommonModule,
    MatButtonModule, 
    TranslateModule,
    NgOptimizedImage],
  templateUrl: './product-related-card.component.html',
  styleUrls: ['./product-related-card.component.scss']
})
export class ProductRelatedCardComponent implements OnInit {

  constructor(
    // private router: Router
    private routingService: RoutingService
  ) {
    
  }

  @Input() item!: any;
  product$ = signal<any | null>(null);

  ngOnInit(): void {
    if(this.item) {
      let productItem = {
        title: this.item.promo_title && this.item.promo_title.trim() !== '' ? this.item.promo_title : this.item.name,
        description: this.item.promo_box && this.item.promo_box.trim() !== '' ? this.item.promo_box : this.item.description,
        thumb:this.item?.thumb_url,
        image: this.item.promo_image_url && this.item.promo_image_url.trim() !== '' ? this.item.promo_image_url : this.item.image,
        sku: this.item.sku,
        id: this.item.id
      }
      this.product$.set(productItem);
    }
  }

 

  clickAction() {
    console.log('clickAction');
    // this.router.navigate([environment.routingBasePath + '/product/' + this.product$().sku]);
    this.routingService.navigate([environment.routingBasePath + '/product/' + this.product$().sku]);
  }
}
